let model = {};

// dữ liệu form
model.dataForm = {};

// validation form
model.validForm = {};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  skip: 0,
  sort: "-1",
  defaultSort: ["-1", "descending"],
  filters: "",
  recordSelected: [],
  dataSearchSalaryPeriod: {
    value: {
      salary_period_id: ""
    },
    valid: {
      salary_period_id: []
    },
    operator: {
      salary_period_id: ""
    }
  },
  dataSearch: {
    value: {},
    valid: {},
    operator: {}
  }
};

export default model;
